import React from 'react';

import multiLogo from '../landingPage/assets/logo.png';
import multiplanLogo from '../../modules/seventhModule/images/logo-multiplan.png';

const AnnouncementPage = () => (
  <div className="flex flex-col min-h-screen bg-[#efeae7] font-sans text-[#2b2b2b]">
    <header className="py-6">
      <div className="max-w-[960px] mx-auto px-5 flex justify-center">
        <img src={multiLogo} alt="Multi" width={126} height={28} />
      </div>
    </header>

    <main className="flex-1 bg-white ">
      <div className="max-w-[960px] mx-auto px-5">
        <div className="px-6 md:px-12 py-10 md:py-14 text-center">
          <h1 className="text-[#0f5a41] text-2xl md:text-3xl font-semibold mb-6">Comunicado aos clientes</h1>
          <div className="space-y-6 text-sm md:text-base leading-relaxed text-[#4a4a4a]">
            <p>Prezado(a),</p>
            <p>
              Em linha com o compromisso de transparência que norteia a relação da Multiplan, titular do aplicativo
              Multi, com seus clientes, comunicamos a confirmação na data de hoje, via relatório de auditoria externa,
              de um acesso não autorizado à base de dados do aplicativo, ocorrido em 10/01/2026.
            </p>
            <p>
              Dentre os dados potencialmente acessados, estão dados cadastrais, incluindo a data de validade com os
              quatro últimos dígitos do cartão de crédito daqueles que os tiverem cadastrado. Reforçamos, no entanto,
              que dados completos de cartão são custodiados externamente por parceiro certificado e não foram acessados.
            </p>
            <p>
              No momento do ocorrido, acionamos imediatamente nossos protocolos de controle e segurança, de modo que o
              acesso foi prontamente interrompido. Desde então, sinalizamos a ocorrência às autoridades competentes e
              conduzimos uma apuração detalhada do ocorrido com auxílio de uma auditoria externa. Não há qualquer
              indício de que os dados eventualmente acessados tenham sido utilizados para qualquer finalidade não
              autorizada que possa causar danos, riscos ou prejuízos aos nossos clientes.
            </p>
            <p>
              A Política de Privacidade do aplicativo, pela qual você pode encontrar mais detalhes sobre as práticas de
              tratamento de dados e sobre como os seus dados são protegidos, pode ser acessada&nbsp;
              <a href="https://www.meumulti.com.br/#/politica-de-privacidade" style={{ color: 'blue' }}>
                aqui
              </a>
              . Caso restem dúvidas sobre o ocorrido, pedimos que entrem em contato conosco pela nossa central de
              atendimento, por meio do e-mail de contato disponível em&nbsp;
              <a href="https://www.multiplan.com.br/a-empresa/privacidade-de-dados/#" style={{ color: 'blue' }}>
                https://www.multiplan.com.br/a-empresa/privacidade-de-dados/#
              </a>
              .
            </p>
            <p>
              Ainda que não haja indícios de uso indevido de informações, recomendamos que você mantenha atenção
              redobrada a comunicações suspeitas ou a qualquer atividade que não reconheça.
            </p>
            <p>
              Lamentamos profundamente o ocorrido e reforçamos nosso compromisso com as melhores práticas de segurança
              da informação, a transparência e o investimento contínuo na proteção dos dados dos nossos clientes.
            </p>
            <p>
              A confiança que você deposita no Multi é muito importante para nós. Ressaltamos, ainda, que o aplicativo
              permanece operacional e seguro, sem que tenham sido identificados quaisquer impactos em seu funcionamento.
            </p>
            <p>Rio de Janeiro, 19 de Janeiro de 2026</p>
            <p>Atenciosamente,</p>
            <p>
              <strong>Equipe Multi</strong>
            </p>
          </div>
        </div>
      </div>
    </main>

    <footer className="bg-[#efeae7] px-5 py-6 border-t border-[#e0e0e0]">
      <div className="max-w-[1280px] mx-auto flex flex-row justify-center items-center relative">
        <img src={multiplanLogo} alt="Multiplan" className="h-7 md:h-7" />
      </div>
    </footer>
  </div>
);

export default AnnouncementPage;
